import { ControlValueAccessor, FormControl } from "@angular/forms";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  template: "",
})
export abstract class ControlValueAccessorComponent<T> implements ControlValueAccessor {
  @Input() formControlName?: string;
  @Input() formControl?: FormControl;
  @Input() hideClearBtn = false;
  @Output() onInput = new EventEmitter<T>();

  protected formControlDisabled = false;
  protected _value: T | any = "";

  get value() {
    return this._value;
  }

  @Input() set value(val: T) {
    this._value = val;
    this.onChange(this._value);
  }

  // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  onChange(_: T) { }

  // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  onTouched() { }

  writeValue(value: T) {
    this._value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDisabled = isDisabled;
  }
}
